import { theme } from '../theme/theme'
import { useWindowDimensions } from './useWindowDimensions'

export function useIsMobile(): boolean {
  const { width } = useWindowDimensions()
  return width < theme.screen.md
}
